import { DotNetIcon } from './DotNetIcon';

/**
 * author: Contributors
 * id E05A9EE4-A599-4195-93F9-0E4024670E81
 * name dot-net
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dot-net.svg
 * tags
 * - Developer / Languages 
 * - Brand / Logo 
 */
export const MicrosoftDotNetIcon = DotNetIcon;
export default MicrosoftDotNetIcon